var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Campaigns = MDB.DPN.Campaigns || {};

(function() {

    var _state = {
        conceptCampaign: 0,
        pendingCampaign: 1,
        activeCampaign: 2,
        expiredCampaign: 3
    };

    var _templates = {
        annotationBtn: [
            '<a data-action="annotation-add" href="javascript:void(0)" class="mdb-icon-btn-primary" ',
            'onclick="MDB.DPN.Campaigns.campaignAnnotationClick(this)">',
                '<i class="fa fa-plus-square" style="font-size:large;"></i>',
            '</a>'
        ].join(''),
        editBtn:  [
            '<a data-action="campaign-edit" href="javascript:void(0)" class="mdb-icon-btn-warning" ',
            'onclick="MDB.DPN.Campaigns.campaignEditClick(this)">',
                '<i class="fa fa-pencil" style="font-size:large;"></i>',
            '</a>'
        ].join(''),
        deleteBtn: [
            '<a data-action="campaign-delete" href="javascript:void(0)" class="mdb-icon-btn-danger" ',
            'onclick="MDB.DPN.Campaigns.campaignDeleteClick(this)">',
                '<i class="fa fa-trash-o" style="font-size:large;"></i>',
            '</a>'
        ].join(''),
        detailsBtn: [
            '<a data-action="campaign-details" href="javascript:void(0)" class="mdb-icon-btn-primary" ',
            'onclick="MDB.DPN.Campaigns.campaignDetailsClick(this)">',
                '<i class="fa fa-window-restore" style="font-size:large;"></i>',
            '</a>'
        ].join(''),
        rapportBtn: [
            '<a data-action="campaign-rapport" href="javascript:void(0)" class="mdb-icon-btn-danger" ',
            'onclick="MDB.DPN.Campaigns.campaignRapportClick(this)">',
                '<i class="fa fa-file-pdf" style="font-size:large;"></i>',
            '</a>'
        ].join(''),
        dashboardBtn: [
            '<a data-action="campaign-dashboard" href="javascript:void(0)" class="mdb-icon-btn-success" ',
            'onclick="MDB.DPN.Campaigns.campaignDashboardClick(this)">',
                '<i class="fa fa-dashboard" style="font-size:large;"></i>',
            '</a>'
        ].join(''),
        annotationDetailsBtn: [
            '<a data-action="annotation-details" href="javascript:void(0)" class="mdb-icon-btn-primary" ',
            'onclick="MDB.DPN.Campaigns.annotationDetailsClick(this)">',
                '<i class="fa fa-window-restore" style="font-size:large;"></i>',
            '</a>'
        ].join(''),
        offerRequestBtn: [
            '<a data-action="offer-request" href="javascript:void(0)" class="mdb-icon-btn-primary" ',
            'onclick="MDB.DPN.Campaigns.Advanced.offerRequestClick(this)">',
                '<i class="fa fa-table" style="font-size:large;"></i>',
            '</a>'
        ].join('')
    };

$.extend(MDB.DPN.Campaigns,
    {
        initCampaignGrid: function (grid, url, parameter, isAnnotations) {
            var def = $.Deferred();

            var annotationFields = {
                Id: { editable: false },
                Date: { nullable: true, editable: false },
                CreatedBy: { nullable: true, editable: false },
                Description: { nullable: true, editable: false },
                Category: { nullable: true, editable: false },
                CampaignName: { nullable: true, editable: false },
                CampaignChannels: { nullable: true, editable: false },
                CampaignTitles: { nullable: true, editable: false }
            },
            campaignFields = {
                Id: { editable: false },
                StartDate: { nullable: true, editable: false },
                EndDate: { nullable: true, editable: false },
                Name: { nullable: true, editable: false},
                Description: { nullable: true, editable: false},
                Titles: { nullable: true, editable: false},
                Type: { nullable: true, editable: false},
                Steps: { nullable: true, editable: false},
                Channels: { nullable: true, editable: false},
                TargetGroups: {nullable: true, editable: false},
                Suppliers: { nullable: true, editable: false},
                HasAccessToCampaignDashboard: { nullable: true, editable: false}
            };

            var annotationColumns = [
                { field: 'Id', title: 'Id', hidden: true},
                { field: 'DateValue', title: MDB.loadResourceString('Dpn_CampaignAnnotationModel_Date_DisplayName'), width: 83},
                { field: 'CreatedByValue', title: MDB.loadResourceString('Dpn_CampaignAnnotationModel_CreatedBy_DisplayName')},
                { field: 'Description', title: MDB.loadResourceString('Dpn_CampaignAnnotationModel_Description_DisplayName')},
                { field: 'CategoryValue', title: MDB.loadResourceString('Dpn_CampaignAnnotationModel_Category_DisplayName')},
                { field: 'CampaignName', title: MDB.loadResourceString('Dpn_CampaignAnnotationModel_CampaignName_DisplayName')},

                //******************Doesn't fit on the screen.. obviously.
                // { field: 'CampaignChannelsValue',    title: MDB.loadResourceString('Dpn_CampaignAnnotationModel_CampaignChannels_DisplayName'),  // },
                // { field: 'CampaignTitlesValue',    title: MDB.loadResourceString('Dpn_CampaignAnnotationModel_CampaignTitles_DisplayName'),  // }
                
            ],
            campaignColumns = [
                { field: 'Id', title: 'Id', hidden: true},
                { field: 'StartValue', title: MDB.loadResourceString('Dpn_CampaignModel_StartValue_DisplayName')},
                { field: 'EndValue', title: MDB.loadResourceString('Dpn_CampaignModel_EndValue_DisplayName')},
                { field: 'Name', title: MDB.loadResourceString('Dpn_CampaignModel_Name_DisplayName')},
                { field: 'Description', title: MDB.loadResourceString('Dpn_CampaignModel_Description_DisplayName')},
                { field: 'GridTitles', title: MDB.loadResourceString('Dpn_CampaignModel_Titles_DisplayName')},
                { field: 'TypeValue', title: MDB.loadResourceString('Dpn_CampaignModel_Type_DisplayName'), width: 48},
                { field: 'GridSteps', title: MDB.loadResourceString('Dpn_CampaignModel_Steps_DisplayName')},
                { field: 'GridChannels', title: MDB.loadResourceString('Dpn_CampaignModel_Channels_DisplayName'), hidden: true},
                { field: 'GridTargetGroups', title: MDB.loadResourceString('Dpn_CampaignModel_TargetGroups_DisplayName'), hidden: true},
                { field: 'GridSuppliers', title: MDB.loadResourceString('Dpn_CampaignModel_Suppliers_DisplayName')},
                { field: 'HasAccessToCampaignDashboard', title: 'DashBoardAccess', hidden: true, id: 'has-access'}
            ];

            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (opts) {

                        if(parameter === null) {
                            parameter = "";
                        }

                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url + parameter, 'GET', opts);
                    },
                    destroy: $.noop
                },
                batch: false,
                pageSize: 10,
                
                schema: {
                    model: {
                        id: 'Id',
                        fields: isAnnotations ? annotationFields : campaignFields
                    }
                },
                error: function (e) {
                    this.cancelChanges();
                    alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
                }
            });

            var loadTooltips = function () {};
            if(parameter == _state.conceptCampaign) {
                loadTooltips = function() {
                        MDB.DPN.Campaigns.loadGridTooltips (grid, 
                            ['[data-action="campaign-delete"]','[data-action="campaign-edit"]','[data-action="annotation-add"]'], 
                            ['Dpn_CampaignManager_Delete_Button_Tooltip','Dpn_CampaignManager_Edit_Button_Tooltip','Dpn_CampaignManager_Annotation_Button_Tooltip']);
                    };
            } else if(parameter == _state.pendingCampaign) {
                loadTooltips = function() {
                    MDB.DPN.Campaigns.loadGridTooltips (grid, 
                        ['[data-action="campaign-details"]','[data-action="annotation-add"]'], 
                        ['Dpn_CampaignManager_Details_Button_Tooltip','Dpn_CampaignManager_Annotation_Button_Tooltip']);
                    };
            } else if(parameter == _state.activeCampaign) {
                loadTooltips = function() {
                       MDB.DPN.Campaigns.loadGridTooltips (grid, 
                            ['[data-action="annotation-add"]','[data-action="campaign-dashboard"]','[data-action="campaign-details"]','[data-action="campaign-rapport"]'], 
                            ['Dpn_CampaignManager_Annotation_Button_Tooltip','Dpn_CampaignManager_Dashboard_Button_Tooltip',
                            'Dpn_CampaignManager_Details_Button_Tooltip','Dpn_CampaignManager_Pdf_Button_Tooltip']);
                    };
            } else if(parameter == _state.expiredCampaign) {
                loadTooltips = function() {
                       MDB.DPN.Campaigns.loadGridTooltips (grid, 
                            ['[data-action="annotation-add"]','[data-action="campaign-dashboard"]','[data-action="campaign-details"]','[data-action="campaign-rapport"]'], 
                            ['Dpn_CampaignManager_Annotation_Button_Tooltip','Dpn_CampaignManager_Dashboard_Button_Tooltip',
                            'Dpn_CampaignManager_Details_Button_Tooltip','Dpn_CampaignManager_Pdf_Button_Tooltip']);
                    };
            }

            var gridConfig = {
                autoBind: true,
                 dataBound: function() {
                    var grid = this;
                    loadTooltips();


                    grid.tbody.find('tr').each(function() {
                        var me = $(this);
                        var item = grid.dataItem(me);
                        
                        if (item.HasAccessToCampaignDashboard === false) {
                            me.find('[data-action="campaign-dashboard"]').hide();
                        }
                    });

                    def.resolve();
                },
                dataSource: dataSource,
                pageable: {
                    change: loadTooltips,
                    refresh: true
                },
                columns: isAnnotations ? annotationColumns : campaignColumns,
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                filterable: false,
                resizable: true
            };
            gridConfig.editable = {
                update: false,
                destroy: false
            };

            if(parameter == _state.conceptCampaign) {
                gridConfig.columns.push(
                    MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-annotations',
                            text: '',
                            template: _templates.annotationBtn
                        }
                    ], 80, MDB.loadResourceString('Dpn_CampaignManager_Annotation_DisplayName'))
                );
                gridConfig.columns.push(
                    MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-edit',
                            text: ' ',
                            template: _templates.editBtn + '&nbsp;&nbsp;&nbsp;'
                        },
                        {
                            name: 'campaign-delete',
                            text: ' ',
                            template: _templates.deleteBtn
                        }
                    ], 80, MDB.loadResourceString('Dpn_CampaignManager_Change_DisplayName'))
                );
            } else if (parameter == _state.pendingCampaign) {
                gridConfig.columns.push(
                    MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-annotations',
                            text: '',
                            template: _templates.annotationBtn
                        }
                    ], 80, MDB.loadResourceString('Dpn_CampaignManager_Annotation_DisplayName'))
                );
                gridConfig.columns.push(
                   MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-details',
                            text: '',
                            template: _templates.detailsBtn
                        }
                    ], 80, MDB.loadResourceString('Dpn_CampaignManager_Details_DisplayName'))
                );
            } else if (parameter == _state.activeCampaign) {
                gridConfig.columns.push(
                    MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-annotations',
                            text: '',
                            template: _templates.annotationBtn
                        }
                    ], 80, MDB.loadResourceString('Dpn_CampaignManager_Annotation_DisplayName'))
                );
                gridConfig.columns.push(
                   MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-dashboard',
                            text: '',
                            template: _templates.dashboardBtn + '&nbsp;&nbsp;&nbsp;'
                        },
                        {
                            name: 'campaign-details',
                            text: '',
                            template: _templates.detailsBtn + '&nbsp;&nbsp;&nbsp;'
                        },
                        {
                            name: 'campaign-rapport',
                            text: '',
                            template: _templates.rapportBtn
                        }
                    ], 100, MDB.loadResourceString('Dpn_CampaignManager_Dashboard_DisplayName'))
                );
            } else if (parameter == _state.expiredCampaign) {
                gridConfig.columns.push(
                    MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-annotations',
                            text: '',
                            template: _templates.annotationBtn
                        }
                    ], 80, MDB.loadResourceString('Dpn_CampaignManager_Annotation_DisplayName'))
                );
                gridConfig.columns.push(
                   MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'campaign-dashboard',
                            text: '',
                            template: _templates.dashboardBtn + '&nbsp;&nbsp;&nbsp;'
                        },
                        {
                            name: 'campaign-details',
                            text: '',
                            template: _templates.detailsBtn + '&nbsp;&nbsp;&nbsp;'
                        },
                        {
                            name: 'campaign-rapport',
                            text: '',
                            template: _templates.rapportBtn
                        }
                    ], 100, MDB.loadResourceString('Dpn_CampaignManager_Dashboard_DisplayName'))
                );
            } else {
                gridConfig.columns.push(
                    MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'annotation-details',
                            text: '',
                            template: _templates.annotationDetailsBtn
                        }
                    ], 50, '')
                );
            }

            grid.kendoGrid(gridConfig);
            return def.promise();
        },
        initSelectionsGrid: function (grid, url) {
            var fields = {
                Id: { editable: false },
                Name: { nullable: true, editable: false },
                TargetGroupValue: { nullable: true, editable: false },
                FollowupChannels: { nullable: true, editable: false },
                Description: { nullable: true, editable: false }
            };

             var columns = [
                { field: 'Id', title: 'Id'},
                { field: 'Name', title: MDB.loadResourceString('CampaignSelectionModel_Name_DisplayName')},
                { field: 'TargetGroupValue', title: MDB.loadResourceString('CampaignSelectionModel_TargetGroup_DisplayName')},
                { field: 'FollowupChannels', template: MDB.KendoConfigBuilder.gridArrayTemplate('FollowupChannels'), title: MDB.loadResourceString('CampaignSelectionModel_FollowupChannels_DisplayName')},
                { field: 'Description', title: MDB.loadResourceString('CampaignSelectionModel_Description_DisplayName')}
            ];

            return initGenericGrid(grid, url, fields, columns);
        },
        initSourceSpecificationsGrid: function (grid, url) {
            var fields = {
                ChannelGroup: { nullable: true, editable: false },
                Channel: { nullable: true, editable: false },
                Source: { nullable: true, editable: false },
                Supplier: { nullable: true, editable: false },
                Budget: { nullable: true, editable: false },
                SetCosts: { nullable: true, editable: false },
                Impressions: { nullable: true, editable: false },
                Cpm: { nullable: true, editable: false },
                Fixed: { nullable: true, editable: false },
                Ctr: { nullable: true, editable: false },
                Clicks: { nullable: true, editable: false },
                Cpc: { nullable: true, editable: false },
                TestType: { nullable: true, editable: false },
                TestNumber: { nullable: true, editable: false },
                Kpl: { nullable: true, editable: false },
                ConversionDv: { nullable: true, editable: false },
                NumberDv: { nullable: true, editable: false },
                Kpa: { nullable: true, editable: false },
                UpsellPercentage: { nullable: true, editable: false },
                CrossSellPercentage: { nullable: true, editable: false }
            };

            var columns = [
                { field: 'ChannelGroup', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_ChannelGroup_DisplayName')},
                { field: 'Channel', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Channel_DisplayName')},
                { field: 'Source', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Source_DisplayName')},
                { field: 'Supplier', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Supplier_DisplayName')},
                { field: 'Budget', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Budget_DisplayName')},
                { field: 'SetCosts', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_SetCosts_DisplayName')},
                { field: 'Impressions', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Impressions_DisplayName')},
                { field: 'Cpm', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Cpm_DisplayName')},
                { field: 'Fixed', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Fixed_DisplayName')},
                { field: 'Ctr', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Ctr_DisplayName')},
                { field: 'Clicks', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Clicks_DisplayName')},
                { field: 'Cpc', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Cpc_DisplayName')},
                { field: 'TestType', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_TestType_DisplayName')},
                { field: 'TestNumber', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_TestNumber_DisplayName')},
                { field: 'Kpl', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Kpl_DisplayName')},
                { field: 'ConversionDv', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_ConversionDv_DisplayName')},
                { field: 'NumberDv', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_NumberDv_DisplayName')},
                { field: 'Kpa', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_Kpa_DisplayName')},
                { field: 'UpsellPercentage', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_UpsellPercentage_DisplayName')},
                { field: 'CrossSellPercentage', title: MDB.loadResourceString('CampaignBusinessCaseSourceSpecifications_CrossSellPercentage_DisplayName')} 
            ];

            return initGenericGrid(grid, url, fields, columns);
        },
        initTestSpecificationsGrid: function (grid, url) {
            var fields = {
                Name: { nullable: true, editable: false },
                TestId: { nullable: true, editable: false },
                Type: { nullable: true, editable: false },
                Channel: { nullable: true, editable: false },
                Description: { nullable: true, editable: false },
                OptimizationType: { nullable: true, editable: false },
                Goal: { nullable: true, editable: false }
            };

            var columns = [
                { field: 'Name', title: MDB.loadResourceString('CampaignTestSpecifications_Name_DisplayName')},
                { field: 'TestId', title: MDB.loadResourceString('CampaignTestSpecifications_TestId_DisplayName')},
                { field: 'Type', title: MDB.loadResourceString('CampaignTestSpecifications_Type_DisplayName')},
                { field: 'Channel', title: MDB.loadResourceString('CampaignTestSpecifications_Channel_DisplayName')},
                { field: 'Description', title: MDB.loadResourceString('CampaignTestSpecifications_Description_DisplayName')},
                { field: 'OptimizationType', title: MDB.loadResourceString('CampaignTestSpecifications_OptimalizationType_DisplayName')},
                { field: 'Goal', title: MDB.loadResourceString('CampaignTestSpecifications_Goal_DisplayName')}
            ];

            return initGenericGrid(grid, url, fields, columns);
        },
        initInboundGrid: function (grid, url) {
            var fields = {
                InboundNumber: { nullable: true, editable: false },
                OriginChannel: { nullable: true, editable: false },
                LocationNumber: { nullable: true, editable: false },
                Channel: { nullable: true, editable: false },
                TitleValue: { nullable: true, editable: false },
                PriceClassValue: { nullable: true, editable: false },
                Description: { nullable: true, editable: false }
            };

            var columns = [
                { field: 'InboundNumber', title: MDB.loadResourceString('CampaignChannelInbound_InboundNumber_DisplayName')},
                { field: 'OriginChannel', title: MDB.loadResourceString('CampaignChannelInbound_OriginChannel_DisplayName')},
                { field: 'LocationNumber', title: MDB.loadResourceString('CampaignChannelInbound_LocationNumber_DisplayName')},
                { field: 'Channel', title: MDB.loadResourceString('CampaignChannelInbound_Channel_DisplayName')},
                { field: 'TitleValue', title: MDB.loadResourceString('CampaignChannelInbound_Title_DisplayName')},
                { field: 'PriceClassValue', title: MDB.loadResourceString('CampaignChannelInbound_PriceClass_DisplayName')},
                { field: 'Description', title: MDB.loadResourceString('CampaignChannelInbound_Description_DisplayName')}
            ];

            return initGenericGrid(grid, url, fields, columns);
        },
        initPropositionsGrid: function (grid, url) {
            var fields = {
                Id: { nullable: true, editable: false },
                Description: { nullable: true, editable: false },
                Premium: { nullable: true, editable: false },
                PremiumCode: { nullable: true, editable: false },
                Duration: { nullable: true, editable: false },
                DurationUnit: { nullable: true, editable: false },
                Price: { nullable: true, editable: false },
                PriceUnit: { nullable: true, editable: false },
                Discount: { nullable: true, editable: false },
                OfferType: { nullable: true, editable: false }
            };

            var columns = [
                { field: 'Id', title: MDB.loadResourceString('CampaignPropositionModel_Id_DisplayName')},
                { field: 'Description', title: MDB.loadResourceString('CampaignPropositionModel_Description_DisplayName')},
                { field: 'Premium', title: MDB.loadResourceString('CampaignPropositionModel_Premium_DisplayName')},
                { field: 'PremiumCode', title: MDB.loadResourceString('CampaignPropositionModel_PremiumCode_DisplayName')},
                { field: 'Duration', title: MDB.loadResourceString('CampaignPropositionModel_Duration_DisplayName')},
                { field: 'DurationUnit', title: MDB.loadResourceString('CampaignPropositionModel_DurationUnit_DisplayName')},
                { field: 'Price', title: MDB.loadResourceString('CampaignPropositionModel_Price_DisplayName')},
                { field: 'PriceUnit', title: MDB.loadResourceString('CampaignPropositionModel_PriceUnit_DisplayName')},
                { field: 'Discount', title: MDB.loadResourceString('CampaignPropositionModel_Discount_DisplayName')},
                { field: 'OfferType', title: MDB.loadResourceString('CampaignPropositionModel_OfferType_DisplayName')}
            ];

            return initGenericGrid(grid, url, fields, columns);
        },
        initSourcesGrid: function (grid, url) {
            var fields = {
                Id: { nullable: true, editable: false },
                Name: { nullable: true, editable: false },
                SupplierName: { nullable: true, editable: false },
                Channel: { nullable: true, editable: false },
                RecruitmentTag: { nullable: true, editable: false },
                SaleChannels: { nullable: true, editable: false },
                IncludeInTotalsValue: { nullable: true, editable: false }
            };

            var columns = [
                { field: 'Id', title: MDB.loadResourceString('CampaignOrigins_Id_DisplayName')},
                { field: 'Name', title: MDB.loadResourceString('CampaignOrigins_Name_DisplayName')},
                { field: 'SupplierName', title: MDB.loadResourceString('CampaignOrigins_Supplier_DisplayName')},
                { field: 'Channel', title: MDB.loadResourceString('CampaignOrigins_Channel_DisplayName')},
                { field: 'RecruitmentTag', title: MDB.loadResourceString('CampaignOrigins_RecruitmentTag_DisplayName')},
                { field: 'SalesChannels', title: MDB.loadResourceString('CampaignOrigins_SalesChannels_DisplayName')},
                { field: 'IncludeInTotalsValue', title: MDB.loadResourceString('CampaignOrigins_CountsForTotal_DisplayName')}
            ];

            return initGenericGrid(grid, url, fields, columns);
        },
        initRequestGrid: function (grid, url) {
            var fields = {
                Id: { nullable: true, editable: false },
                Created: { nullable: true, editable: false },
                UserId: { nullable: true, editable: false },
                UserName: { nullable: true, editable: false },
                LabelsValue: { nullable: true, editable: false },
                Url: { nullable: true, editable: false }
            };

            var columns = [
                { field: 'Id', title: 'Id', hidden: true},

                { field: 'Created', title: MDB.loadResourceString('CampaignOfferRequestModel_Created_DisplayName'), type: 'date', 
                  template: "#= kendo.toString(kendo.parseDate(Created), 'dd MMM yyyy HH:mm') #" },

                { field: 'UserId', title: 'UserId', hidden: true},
                { field: 'UserName', title: MDB.loadResourceString('CampaignOfferRequestModel_UserName_DisplayName')},
                { field: 'LabelsValue', title: 'Labels'},
                { field: 'Url', title: 'Url', hidden: true},
                MDB.KendoConfigBuilder.gridCommandColumn([
                        {
                            name: 'offer-request',
                            text: '',
                            template: _templates.offerRequestBtn
                        }
                    ], null, 'Offer request')
            ];

            return initGenericGrid(grid, url, fields, columns);
        },
        loadGridTooltips: function (grid, selectors, tooltips) {
            grid = $(grid);
            
            selectors.forEach(function (selector, i) {
                grid.find(selector).each(function() {
                    MDB.DPN.Campaigns.loadTooltip($(this), MDB.loadResourceString(tooltips[i]), { placement: 'left' });
                });
            });
        }
    });

    function initGenericGrid(grid, url, fields, columns) {
        var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (opts) {
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts);
                    },
                    destroy: $.noop
                },
                batch: false,
                pageSize: 10,
                
                schema: {
                    model: {
                        id: 'Id',
                        fields: fields
                    }
                },
                error: function (e) {
                    this.cancelChanges();
                    MDB.Notify.bootstrapDanger(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
                }
            });

            var gridConfig = {
                autoBind: true,
                dataSource: dataSource,
                columns: columns,
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                filterable: false,
                resizable: true
            };
            gridConfig.editable = {
                update: false,
                destroy: false
            };

        return grid.kendoGrid(gridConfig);
    }
})();